import { OfferNetworkProvider } from "@redotech/crdb-enums/marketing/offer-network-provider";
import { offerPlacementSummarySchema } from "@redotech/order-tracking-common/offer-network/offer-placement";
import { OfferPlacementSurface } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const listOfferPlacements = {
  name: "listOfferPlacements" as const,
  input: z.object({
    provider: createEnum(Object.values(OfferNetworkProvider)).optional(),
    surface: createEnum(Object.values(OfferPlacementSurface)).optional(),
  }),
  output: z.object({ placements: z.array(offerPlacementSummarySchema) }),
};
